'use strict';

require('./index.less');


/*****************
 ** WEBPACK FOOTER
 ** ./components/style/index.js
 ** module id = 242
 ** module chunks = 0
 **/